import { Text } from '@/components/ui/text';
import Ionicons from '@expo/vector-icons/Ionicons';
import React from 'react';
import { Pressable, View } from 'react-native';

export interface SettingsItemData {
  icon: string;
  title: string;
  action: () => void;
  disabled?: boolean;
  destructive?: boolean;
  testID?: string;
}

export interface SettingsToggleItemData {
  icon: string;
  title: string;
  value: boolean;
  onToggle: (value: boolean) => void;
  disabled?: boolean;
  testID?: string;
}

interface SettingsItemProps {
  item: SettingsItemData;
  isLast?: boolean;
}

export function SettingsItem({ item, isLast = false }: SettingsItemProps) {
  const labelColor = item.disabled
    ? 'text-muted-foreground'
    : item.destructive
      ? 'text-destructive'
      : 'text-foreground';

  return (
    <Pressable
      testID={item.testID}
      onPress={item.action}
      accessibilityRole="button"
      accessibilityState={{ disabled: Boolean(item.disabled) }}
      className={`flex-row items-center py-4 ${!isLast ? 'border-b border-border' : ''}`}
      style={{
        opacity: item.disabled ? 0.4 : 1,
      }}
      disabled={item.disabled}
    >
      <View className="w-8 items-center mr-3">
        <Ionicons
          name={item.icon as any}
          size={22}
          className={labelColor}
        />
      </View>
      <Text
        className={`flex-1 text-base ${labelColor}`}
      >
        {item.title}
      </Text>
      {/* A chevron promises navigation; a disabled row can't navigate, so drop it. */}
      {!item.disabled && (
        <Ionicons
          name="chevron-forward"
          size={20}
          className={item.destructive ? 'text-destructive' : 'text-muted-foreground'}
        />
      )}
    </Pressable>
  );
}
